import getNodeScroll from "./getNodeScroll.js";
export default (function (scrollParents) {
  return scrollParents.reduce(function (scroll, scrollParent) {
    var nodeScroll = getNodeScroll(scrollParent);
    scroll.scrollTop += nodeScroll.scrollTop;
    scroll.scrollLeft += nodeScroll.scrollLeft;
    return scroll;
  }, {
    scrollTop: 0,
    scrollLeft: 0
  });
});